import React from "react";
import { connect } from "react-redux";
import { callService } from "../tools";

const mapState = (state) => {
	return {
		familiar: state.af.familiar,
		listaPolizas: state.af.listaPolizas,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		goTo: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO", "paso": paso });
		},
		guardarPolizas: (listaGuardar) => {
			dispatch({ "type": "AF_EDITAR_POLIZAS", "listaGuardar": listaGuardar });
		},
		guardarVigencia: (listaVigencia) => {
			dispatch({ "type": "AF_EDITAR_VIGENCIA", "listaVigencia": listaVigencia });
		},
		addEvento: (evento) => {
			dispatch({ "type": "AF_SET_EVENT", "evento": evento});
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class GestionarAgregar extends React.Component {
	state = {
		polizasIds: [],
		vigenciaIds: {}
	}

	handleChangeChk = (_item, event) => {
		let polizas = this.state.polizasIds;
		let vigencia = this.state.vigenciaIds;

		if(event.target.checked) {
			polizas.push(_item.generales.numPoliza);
			vigencia[_item.generales.numPoliza] = _item.generales.fchVigenciaInicial.split("/").reverse().join("");
		} else {
			let eliminar = polizas.indexOf(_item.generales.numPoliza);
			if (eliminar != -1) {
				polizas.splice(eliminar,1);
			}
		}

		this.setState({polizasIds: polizas, vigenciaIds: vigencia});
	}

	componentWillMount = () => {
		let polizas = [];
		for(let i in this.props.familiar.polizas) {
			polizas.push(this.props.familiar.polizas[i]);
		}
		this.setState({polizasIds: polizas});
		if(this.props.familiar.vigencias) {
			this.setState({vigenciaIds: this.props.familiar.vigencias});
		}
	}

	volver = () => {
		// GOOGLE TAG MANAGER //
		this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_GESTPOLIZAS-CANCELAR", "dispositivo": this.props.dispositivo });
		
		this.props.goTo(0);
		this.props.addEvento("BtnCancelar-GestionarPolizas");
	}

	guardar = () => {
		let listaGuardar = this.state.polizasIds;
		let listaVigencia = this.state.vigenciaIds;

		this.props.familiar.polizas = listaGuardar;
		this.props.guardarPolizas(listaGuardar);
		this.props.guardarVigencia(listaVigencia);
		this.props.addEvento("BtnGuardar-GestionarPolizas");
		this.props.goTo(0);
	}

	guardadoFinal = () => {
		let $this = this;
		let listaGuardar = this.state.polizasIds;
		let listaVigencia = this.state.vigenciaIds;

		$this.props.loader(true);
		let llamaServicio = new callService({
			service: "accesoFamiliar.editarFamiliar",
			secure: true,
			data: {
				familiar: this.props.familiar.id,
				polizas: listaGuardar,
				vigencias: listaVigencia
			}
		}).execute().then((respuesta) => {
			// GOOGLE TAG MANAGER //
			$this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_GESTPOLIZAS-GUARDAR", "dispositivo": $this.props.dispositivo });
		
			console.log("Respuesta", respuesta);
			$this.props.loader(false);
			$("#modal-gestionar").modal("hide");
		}).catch((error) => {
			console.log("error", error);
			$this.props.loader(false);
			$this.props.alerta(error.message.mensaje);
		});
	}

	render() {
		return (
			<div>
				<h5><i><img src={ require("../img/documentos-icono.png") } /></i>Gestionar pólizas</h5>
				<hr className="mt-34" />
				<div className="row ">
					<div className="col-xs-12 mb-20">
						<div className="row acceso-container">
							<div className="col-md-2 col-xs-2">
								<img src={ require("../img/circle_contratante.png") } />
							</div>
							<div className="col-xs-8 col-md-8">
								<p><span className="blue-text"><b>{this.props.familiar.nombre}</b></span></p>
								{ this.props.familiar.pendiente == true &&
									<p><span className="blue-circle"></span><small className="gray-text">Invitación aceptada</small></p>
								}
								{ this.props.familiar.pendiente == false &&
									<p><span className="red-circle-no"></span><small className="gray-text">Pendiente de aceptar</small></p>
								}
							</div>
							<div className="col-xs-2 no-pad-left text-center">
								<span className="texto-20 orange-text">{this.state.polizasIds.length}</span><br />
								<small className="gray-text">Pólizas</small>
							</div>
						</div>
					</div>
				</div>
				<div className="row acceso-container">
					<div className="col-xs-12 mb-20">
						<div className="texto-17 blue-text">
							<p>Agrega o quita el acceso de alguna de tus pólizas.</p>
						</div>
						<div className="overflow-wrap mt-25">
							<ul>
								{ this.props.listaPolizas.map((item, i) => {
									let activo = (this.state.polizasIds.indexOf(item.generales.numPoliza) != -1)? true : false;
									return (
										<li key={i} className="clearfix">
											<div className="col-xs-6" style={{"padding":"0 5px"}}>
												<h6>{item.vehiculo.descripcion}</h6>
												<p>
													<i className="center-icon"><img src={ require("../img/icon-poliza.png") } /></i>
													Póliza N: {item.generales.numPoliza}
												</p>
											</div>
											<div className="col-xs-4 text-right" style={{"padding":"0 5px"}}>
												<h6><b>{item.vehiculo.placas}</b></h6>
												<p><span className="blue-text">MODELO {item.vehiculo.modelo}</span></p>
											</div>
											<div className="col-xs-2" style={{"padding":"0 5px", "textAlign":"center"}}>
												<div className="checkbox-blue text-right">
													<input type="checkbox" defaultChecked={activo} onChange={this.handleChangeChk.bind(this, item)} />
													<label></label>
												</div>
											</div>
										</li>
									);
								})}
							</ul>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-30">
							<a onClick={this.volver.bind(this)}>Cancelar</a>
							<a onClick={this.guardadoFinal.bind(this)} className="orange-btn">Guardar</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(GestionarAgregar);



// WEBPACK FOOTER //
// ./src/acceso-familiar/GestionarAgregar.cmpt.js